exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uikit-tooltip {\n  display: none;\n}\n.uikit-tooltip--attached {\n  display: inline;\n}\n.uikit-tooltip__content {\n  background: rgba(158,158,158,0.9);\n  color: #000;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 22px;\n  display: inline-block;\n  padding: 5px 16px;\n  position: absolute;\n  text-transform: initial;\n  width: auto;\n  opacity: 0;\n  pointer-events: none;\n}\n.uikit-tooltip__content.menuable__content__active {\n  opacity: 0.9;\n}\n.uikit-tooltip__content--fixed {\n  position: fixed;\n}\n.uikit-tooltip__content[class*=\"-active\"] {\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n}\n.uikit-tooltip__content[class*=\"enter-active\"] {\n  transition-duration: 150ms;\n}\n.uikit-tooltip__content[class*=\"leave-active\"] {\n  transition-duration: 75ms;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/uikit/components/AppTooltip/AppTooltip.styl
// module id = 41531c8c4984128a1b30
// module chunks = 89